import { useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { getAllPermissions } from './permissionsApi';

export const useGetAllPermissions = () => {
  return useQuery({
    queryKey: ['permissions'],
    queryFn: getAllPermissions,
    onError: (error) => {
      console.error('Failed to fetch permissions: ', error);
      toast.error(
        'Failed to fetch permissions: ' + (error.message || 'Unknown error')
      );
    },
  });
};
